import InsertCash from './InsertCash.jsx';

export default InsertCash;